module.exports = __webpack_public_path__ + "img/11.e9a2868d.png";